import {Amount, ClaimGuarantorResponsibility, CurrencyType, InputField, ToastContext} from '@enter/core';

import {RootStore} from 'stores';
import {Formik, FormikHelpers as FormikActions, FormikProps} from 'formik';
import React, {useContext} from 'react';
import * as Yup from 'yup';
import * as S from './maxpr-provider-dialog.styles';
import {inject, observer} from "mobx-react";
import {DialogContext} from "../../../../services";
import _ from "lodash";

export type IMaxPRValues = ClaimGuarantorResponsibility;

const initialValues: IMaxPRValues = {
    maximumGuarantorResponsibility:{
        amount: '0',
        currency: CurrencyType.USD,
    }
};

type InvoiceItemDialogProps = {
    claimId: string;
    maximumGuarantorResponsibility?: Amount;
    onClose: () => void;
    onSubmit: () => void;
};

const schema = Yup.object().shape({
    maximumGuarantorResponsibility: Yup.object().shape({
        amount: Yup.string().required('Maximum patient responsibility is required'),
    }),
});

export const MaxProviderPRDialog: React.FunctionComponent<InvoiceItemDialogProps> = inject('rootStore')(
    observer(
        (props: InvoiceItemDialogProps): React.ReactElement => {
            const dialogContext = useContext(DialogContext);
            const toastContext = useContext(ToastContext);

            const initial: ClaimGuarantorResponsibility = {
                maximumGuarantorResponsibility: props.maximumGuarantorResponsibility ? props.maximumGuarantorResponsibility : {
                    amount: '0',
                    currency: CurrencyType.USD
                }
            };

            const rootStore: RootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }

            const { claimStore } = rootStore;
            const { claimId, onClose, onSubmit } = props;

            const handleCancel = (): void => {
                onClose?.();
            };

            const handleSubmit = async (
                claimGuarantorResponsibility: ClaimGuarantorResponsibility,
                { setSubmitting }: FormikActions<any>,
            ): Promise<void> => {
                setSubmitting(true);

                try {
                    await claimStore.updateClaimMaxGuarantorResponsibility(claimGuarantorResponsibility, claimId );
                    toastContext.notify?.('Maximum Patient Responsibility was updated.', 'right');
                } catch (err) {
                    dialogContext.showError(err);
                } finally {
                    setSubmitting(false);
                    onSubmit?.();
                }
            };

            return (
                <S.DialogBody>
                    <Formik initialValues={initial} validationSchema={schema} onSubmit={handleSubmit}>
                        {(formik: FormikProps<ClaimGuarantorResponsibility>): React.ReactElement => (
                            <>
                                <S.InputRow>
                                    <S.InputAmount>
                                        <S.Label>Amount</S.Label>
                                        <S.FormField
                                            name="maximumGuarantorResponsibility.amount"
                                            maxLength={100}
                                            component={InputField}
                                            type="number"
                                        />
                                    </S.InputAmount>
                                </S.InputRow>
                                <S.ButtonGroup
                                    changed={true}
                                    useNotify={false}
                                    onCancel={handleCancel}
                                    onSave={formik.submitForm}
                                    saveLabel="Save"
                                    saveNotice="Item added"
                                />
                            </>
                        )}
                    </Formik>
                </S.DialogBody>
            );
        },
    ),
);
